export const environment = {
  production: false,
  bankIdUrl: 'https://foto-app-test.sealthedeal.se/service',
  apiUrl: 'https://foto-app-test.sealthedeal.se/api',
  theUrl: 'https://foto-app-test.sealthedeal.se',
  serviceType: 'dualButtons'
}
